const moduloAmbiente = {
    currentEnvironment    : 'QA',
    environmentLocal      : 'LOCAL',
    environmentDesarrollo : 'DESARROLLO',
    environmentQA         : 'QA',
    environmentProduccion:  'PRODUCCION',
    qa: {
        ip:               'https://apiqas2-lf.lafabril.com.ec/qrk/app/ms/',
        ip_:              'http://10.100.5.5:8080/app/ms/',
        authenticate:     'seguridad-api/v1/api/authenticate',
        urlSeguridad:     'seguridad-api/v1/api/services/',
        urlDatosMaestros: 'dmaestros-api/v1/api/services/',
        urlPortaCompras:  'compra-api/v1/api/services/',
        urlVmi:           'vmi-api/v1/api/service/',
        urlFinanciero:    'financiero-api/v1/api/services/',
        urlHorasExtra:    'nomina-api/v1/api/services/',
        urlRPlus:         'rplus-api/v1/api/service',
        urlVenta:         'venta-api/v1/api/service/',
        urlSustento:      'sustento-api/v1/api/service/',
        urlVdi:           'vdi-api/v1/api/services',
        urlDistribuidor:  'distribuidor-api/v1/api/service/',
        urlBalanzaApi:    'balanza-api/v1/api/service/',
        urlPromociones:   'promocion/v1/api/service',
        urlPresupuestoComercial:  'presupuesto-comercial-api/v1/api/services/',
        urlAutoconsumo:  'pedido-autoconsumo-api/v1/api/service/',
        urlIoIndustrias: 'industria-io-api/v1/api/services/',
        comedor:          'only-control-api/v1/api/service/',
        nomina:           'nomina-api/v1/api/services/',
        urlComisiones:    'comisiones-api/v1/api/service/',
        dotacion:           'nomina-api/v1/api/services/',
        urlLogistica:     'logistica-api/v1/api/services/',
        urlSensoresOnlyControl: 'https://mta-bascula-mp.lafabril.com.ec:8089/',
    }
}
export { moduloAmbiente }
